import { SET_ASSET_TO_CAST, SET_PIN_NEEDED } from 'store/cast/constants';
import { StreamTypes } from 'store/player/actions.types';

import { VideoItem } from 'services/data-manager/types';

export const setPinNeeded = (pinNeeded: boolean) => ({
    type: SET_PIN_NEEDED,
    payload: {
        pinNeeded,
    },
});

export const setAssetToCast = (
    videoItem: VideoItem,
    playbackType: StreamTypes,
) => ({
    type: SET_ASSET_TO_CAST,
    payload: {
        videoItem,
        playbackType,
    },
});
